import { render, staticRenderFns } from "./standardCourseCard.vue?vue&type=template&id=b7bd9fd2&"
import script from "./standardCourseCard.vue?vue&type=script&lang=js&"
export * from "./standardCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./standardCourseCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports